









































import { Component, Prop, Vue } from "vue-property-decorator";
import { type } from "@/config/files.config.json";
import { splitString } from "@/services/strings";
import { FileRender } from "@/modules/sockets/sockets-module-upload";
import { EventListener } from "@/@types/dom";

import Progress from "./progress.vue";

@Component({
  components: { "progress-component": Progress },
})
export default class UploadingMedias extends Vue {
  @Prop({ type: String, default: "" }) videoName!: string;
  @Prop({ type: String, default: "video" }) upload!: string;
  @Prop({ type: String, default: "" }) uri!: string;
  @Prop({ type: String, default: "" }) path!: string;

  show = true;
  files: FileList | null = null;
  uploade: Array<{ name: string; progress: number }> = [];

  $refs!: {
    fileBox: HTMLInputElement;
    uploadButton: HTMLButtonElement;
  };

  fileChosen(): void {
    this.files = this.$refs.fileBox.files;
    if (!this.files || !this.files?.length) {
      this.$bvModal.msgBoxConfirm(String(this.$i18n.t("error.empty-file")));
      return;
    }

    for (const file of this.files) {
      if (!this.getFileFormat(file.type.toLowerCase())) continue;
      const res = new FileRender(file, this.path, this.uri, this.upload);
      res.connect();
      res.startUpload();
    }
  }

  isDone(event: CustomEvent): void {
    if (!this.files) return;
    const i = this.uploade.findIndex((el) => el.name == event.detail);
    const data = { name: event.detail, progress: 100 };
    if (i < 0) this.uploade.push(data);
    else this.$set(this.uploade[i], "progress", 100);

    if (this.uploade.length != this.files.length) return;
    for (const file of this.uploade) {
      if (file.progress != 100) return;
    }
    this.$emit("done");
  }

  isProgress(e: CustomEvent): void {
    if (!e.detail.progress) return;
    const i = this.uploade.findIndex((el) => el.name == e.detail.name);
    if (i < 0)
      this.uploade.push({
        name: e.detail.name,
        progress: e.detail.progress,
      });
    else this.$set(this.uploade[i], "progress", e.detail.progress);
  }

  getFileFormat(string: string | undefined): boolean {
    const space = "/";
    const format = this.upload == "video" ? type.video : type.audio;
    if (string === undefined) return false;
    const splitArr = splitString(string, space);
    return format.includes(splitArr[splitArr.length - 1]);
  }

  mounted(): void {
    document.addEventListener("done", this.isDone as EventListener);
    document.addEventListener("progress", this.isProgress as EventListener);
  }

  destroyed(): void {
    window.removeEventListener("done", this.isDone as EventListener);
    window.removeEventListener("progress", this.isProgress as EventListener);
    this.uploade = [];
    this.files = null;
  }
}
